import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

export const Modal = ({ isOpen, onClose, title, children }: ModalProps) => {
  useEffect(() => {
    if (isOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'unset';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-[#1A0A30]/40" onClick={onClose} />

      <div className="relative bg-white w-full max-w-[640px] rounded-[24px] shadow-2xl overflow-hidden animate-in fade-in duration-200">
        <div className="max-h-[650px] overflow-y-auto custom-scroll">
          <div className="p-6 flex items-center justify-center ">
            <h2 className="text-[clamp(18px,1.5vw,22px)] font-bold text-[#1A0A30]">{title}</h2>
          </div>

          <hr className="mx-8 border-[#F0EEF9]" />

          <div className="px-3 pt-5  sm:px-8 sm:py-4 overflow-y-auto max-h-[70vh] sm:max-h-none">
            {children}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
